export interface PortfolioAttributionBenchmarkDto {
  current: PortfolioAttributionBenchmark;
  previous: PortfolioAttributionBenchmark;
  portfolioAttributionTotal: PortfolioAttributionBenchmarkFM;
  portfolioAttributionTotalAdjusted: PortfolioAttributionBenchmarkFM;
  currentTTM: PortfolioAttributionBenchmarkFM;
  previousTTM: PortfolioAttributionBenchmarkFM;
}

export interface PortfolioAttributionBenchmark {
  portfolioAttributionBenchmarks: PortfolioAttributionBenchmarkValues[];
  portfolioAttributionBenchmarkFM: PortfolioAttributionBenchmarkFM;
}

export interface PortfolioAttributionBenchmarkValues {
  id: number;
  portfolioAttributionBenchmarkFmId: number;
  internationalEquity: number;
  localEquity: number;
  internationalFixedIncome: number;
  localFixedIncome: number;
  alternativeInvestment: number;
  cashAndMoneyMarket: number;
  dateCreated: Date;
  isExisting: boolean;
  isUpdated: boolean;
  isCurrentMonth: boolean;
  dateRepresentation: string;
}

export interface PortfolioAttributionBenchmarkFM {
  id: number;
  internationalEquity: number;
  localEquity: number;
  internationalFixedIncome: number;
  localFixedIncome: number;
  alternativeInvestment: number;
  cashAndMoneyMarket: number;
  attributionDate: Date;
}

export const defaultPortfolioAttributionBenchmarkFM: PortfolioAttributionBenchmarkFM =
  {
    id: 0,
    internationalEquity: 0,
    localEquity: 0,
    internationalFixedIncome: 0,
    localFixedIncome: 0,
    alternativeInvestment: 0,
    cashAndMoneyMarket: 0,
    attributionDate: new Date(),
  };

export const defaultPortfolioAttributionBenchmark: PortfolioAttributionBenchmarkValues =
  {
    id: 0,
    portfolioAttributionBenchmarkFmId: 0,
    internationalEquity: 0,
    localEquity: 0,
    internationalFixedIncome: 0,
    localFixedIncome: 0,
    alternativeInvestment: 0,
    cashAndMoneyMarket: 0,
    dateCreated: new Date(),
    isCurrentMonth: false,
    isExisting: false,
    isUpdated: false,
    dateRepresentation: "",
  };

export interface DialogData {
  client: string;
  addingANewBenchmarkEntry: boolean;
  portfolioAttributionBenchmark: PortfolioAttributionBenchmarkValues;
}

export interface AssetClassPerformance {
  name: string;
  performance?: number;
  benchmarkPerformance?: number;
}

export interface PortfolioAttributionContribution {
  assetClassPerformance: PortfolioAttributionBenchmarkFM;
  assetClassBenchmarkPerformance: PortfolioAttributionBenchmarkFM;
  contributionByInvestmentTrailingTwelveMonthsTopThree: AssetClassPerformance[];
  contributionByInvestmentTrailingTwelveMonthsBottomThree: AssetClassPerformance[];
  contributionByInvestmentForLastQuarterTopThree: AssetClassPerformance[];
  contributionByInvestmentForLastQuarterBottomThree: AssetClassPerformance[];
}

export const defaultAssetClassNames = [
  {
    longName: "Cash And Money Market",
    shortName: "CASH & MM",
    dtoName: "cashAndMoneyMarket",
  },
  {
    longName: "Alternative Investments",
    shortName: "ALT INV",
    dtoName: "alternativeInvestment",
  },
  {
    longName: "International Equity",
    shortName: "INTL EQ",
    dtoName: "internationalEquity",
  },
  { longName: "Local Equity", shortName: "LOCAL EQ", dtoName: "localEquity" },
  {
    longName: "International Fixed Income",
    shortName: "INTL FI",
    dtoName: "internationalFixedIncome",
  },
  {
    longName: "Local Fixed Income",
    shortName: "LOCAL FI",
    dtoName: "localFixedIncome",
  },
];

export const defaultPortfolioAttributionBenchmarkDto: PortfolioAttributionBenchmarkDto =
  {
    current: {
      portfolioAttributionBenchmarks: [
        {
          id: 0.0,
          portfolioAttributionBenchmarkFmId: 0.0,
          internationalEquity: 0.0,
          localEquity: 0,
          internationalFixedIncome: 0,
          localFixedIncome: 0,
          alternativeInvestment: 0,
          cashAndMoneyMarket: 0,
          dateCreated: new Date(),
          isExisting: false,
          isUpdated: false,
          isCurrentMonth: false,
          dateRepresentation: "",
        },
      ],
      portfolioAttributionBenchmarkFM: {
        id: 0,
        internationalEquity: 0,
        localEquity: 0,
        internationalFixedIncome: 0,
        localFixedIncome: 0,
        alternativeInvestment: 0,
        cashAndMoneyMarket: 0,
        attributionDate: new Date(),
      },
    },
    previous: {
      portfolioAttributionBenchmarks: [],
      portfolioAttributionBenchmarkFM: {
        id: 0,
        internationalEquity: 0,
        localEquity: 0,
        internationalFixedIncome: 0,
        localFixedIncome: 0,
        alternativeInvestment: 0,
        cashAndMoneyMarket: 0,
        attributionDate: new Date(),
      },
    },
    portfolioAttributionTotal: {
      id: 0,
      internationalEquity: 0,
      localEquity: 0,
      internationalFixedIncome: 0,
      localFixedIncome: 0,
      alternativeInvestment: 0,
      cashAndMoneyMarket: 0,
      attributionDate: new Date(),
    },
    portfolioAttributionTotalAdjusted: {
      id: 0,
      internationalEquity: 0,
      localEquity: 0,
      internationalFixedIncome: 0,
      localFixedIncome: 0,
      alternativeInvestment: 0,
      cashAndMoneyMarket: 0,
      attributionDate: new Date(),
    },
    currentTTM: {
      id: 0,
      internationalEquity: 0,
      localEquity: 0,
      internationalFixedIncome: 0,
      localFixedIncome: 0,
      alternativeInvestment: 0,
      cashAndMoneyMarket: 0,
      attributionDate: new Date(),
    },
    previousTTM: {
      id: 0,
      internationalEquity: 0,
      localEquity: 0,
      internationalFixedIncome: 0,
      localFixedIncome: 0,
      alternativeInvestment: 0,
      cashAndMoneyMarket: 0,
      attributionDate: new Date(),
    },
  };



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/models/PortfolioAttributionBenchmarkDto .ts